export enum CouponOfferType {
  ADVANCED = 'advanced',
  PERCENT_OFF = 'percentOff',
  PRICE_OFF = 'priceOff',
}
